import React, { useEffect } from "react";
import Header from "./Header";
import LeftSidebar from "./LeftSidebar.js";
import MapView from "./Map.js";
import Trends from "./Trends.js";
import RightSidebar from "./RightSidebar.js";
import TopBar from "./TopBar.js";
import classes from "./Index.module.css";
import { useDispatch, useSelector } from 'react-redux';
import { selectionsSliceActions } from "../store/slices/selectionsSlice";
import { aggSliceActions } from "../store/slices/aggSlice.js";
import { apiUrl } from "../configs/api";

const Index = () => {
    const dispatch = useDispatch();
    const seletedCountry = useSelector(state => state.selection.country)
    const displayaiagent = useSelector(state => state.selection.aiagent)
    const hasSidebars = Boolean(seletedCountry || displayaiagent);
    const mapIsWide = Boolean(seletedCountry && !displayaiagent);
    const mapHasAi = Boolean(displayaiagent);
    const toggleAiAgent = () => {
        // Reset the map's population toggle to Total when opening the AI agent,
        // so a fresh chat starts from the default metric.
        if (!displayaiagent) {
            dispatch(selectionsSliceActions.setPopulationType("total"));
        }
        dispatch(selectionsSliceActions.setAIagent(!displayaiagent));
    };

    const requestMap = {
        dtm_api_viz_global_annual_trend: aggSliceActions.setGlobalAnnualTrend,
        dtm_api_viz_annual_driver_trend: aggSliceActions.setAnnualDriverTrend,
        dtm_api_viz_annual_region_trend: aggSliceActions.setAnnualRegionTrend,
        dtm_api_viz_regional_aggregate: aggSliceActions.setRegionalAgg,
        dtm_api_viz_country_aggregate: aggSliceActions.setCountryAgg,
        dtm_api_viz_operation_list: aggSliceActions.setOperationList,
        dtm_api_viz_countries_list: aggSliceActions.setCountriesList,
        dtm_api_viz_displacement_reasons: aggSliceActions.setDisplacementReasons,
        dtm_api_viz_regions: aggSliceActions.setRegion,
        dtm_api_viz_rounds: aggSliceActions.setRounds,
    };

    async function fetchData(requestType, actionCreator) {
        try {
            const urlencoded = new URLSearchParams();
            urlencoded.append("requestType", requestType);
            const response = await fetch(apiUrl("/dtm_cdw/get"), {
                method: 'POST',
                body: urlencoded,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
            });

            if (!response.ok) {
                throw new Error(`An error occured: ${response.status}`);
            }

            const text = await response.text();
            if (!text) {
                console.warn(`Empty response for ${requestType}, skipping.`);
                return;
            }
            const data = JSON.parse(text);
            dispatch(actionCreator(data));
        } catch (error) {
            console.error(`Failed to fetch ${requestType}:`, error);
        }
    }

    useEffect(() => {
        const requestEntries = Object.entries(requestMap);
        Promise.all(
            requestEntries.map(([requestType, actionCreator]) =>
                fetchData(requestType, actionCreator)
            )
        );
    }, [dispatch, fetchData]);
        

    return (
        <>
            <div className={classes.app_shell}>
            <Header />
              <TopBar />
            <div className="container">

            </div>
            <div
                className={`${classes.box}${hasSidebars ? "" : ` ${classes.box_full}`}`}
            >
                <div className={`${classes.left_sidebar_section}${displayaiagent ? ` ${classes.sidebar_visible}` : ` ${classes.sidebar_hidden}`}`}>
                    {displayaiagent && (<LeftSidebar />)}
                </div>

                <div className={`${classes.map_section}${hasSidebars ? "" : ` ${classes.map_section_full}`}`}>
                    <div
                        className={`${mapIsWide
                            ? classes.map_inner_wide
                            : mapHasAi
                                ? classes.map_inner_ai
                                : hasSidebars
                                    ? "container"
                                    : classes.map_inner_full} ${classes.map_inner}`}
                    >
                        <MapView />
                         <Trends />
                    </div>
                </div>

                <div className={`${classes.right_sidebar_section}${seletedCountry ? ` ${classes.sidebar_visible}` : ` ${classes.sidebar_hidden}`}`}>
                    {seletedCountry && (<RightSidebar />)}
                </div>

            </div>
            </div>

            <button
                type="button"
                className={classes.chat_fab}
                aria-label="Open DTM AI Agent chat"
                onClick={toggleAiAgent}
            >
                <span className={classes.chat_fab_icon} />
                <span className={classes.chat_fab_text}>DTM AI Agent</span>
            </button>

            {/* Unclosable desktop-only notice. Shown purely via CSS below the
                mobile breakpoint; covers the viewport so the app underneath
                can't be interacted with. */}
            <div className={classes.desktop_only} role="alertdialog" aria-modal="true" aria-label="Desktop recommended">
                <div className={classes.desktop_only_card}>
                    <svg className={classes.desktop_only_icon} viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <rect x="2" y="3" width="20" height="14" rx="2" />
                        <path d="M8 21h8M12 17v4" />
                    </svg>
                    <h2 className={classes.desktop_only_title}>Best viewed on desktop</h2>
                    <p className={classes.desktop_only_text}>
                        The DTM API Data Visualizer is optimized for larger screens.
                        Please open it on a desktop or laptop for the full experience.
                    </p>
                </div>
            </div>
        </>
    )
}

export default Index
